<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="title">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'generalMaster' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
              class="mr-n2 mt-10" style="opacity:.6;">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Response Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" counter="100" pattern="[a-zA-Z\s]+"
                  placeholder="Enter valid character" required v-model.trim="classObj.responseType"
                  maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Value
                </label>
                <v-text-field title="Value" class="my-0 py-1" min="0" max="5" type="number"
                  placeholder="Enter value from 0 to 5" v-model.trim="classObj.value" maxlength="1">
                </v-text-field>

              </v-col>

              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'saveClass',
  components: {
    MaterialCard
  },
  data () {
    return {
      title: 'Add Response',

      classObj: {
        responseType: '',
        value: '',
        isActive: true
      },
      hasClicked: false,
      loader: false
    }
  },
  created () {
    // this.title = this.classId ? 'Edit Class' : 'Add Class'
  },
  methods: {
    save: async function () {
      this.hasClicked = true
      this.loader = true
      try {
        let res = await http.post(`${constants.API_URL}/api/audit/audit-response/add`, this.classObj)
        console.log('test', res)
        this.$router.push({ name: 'generallistAuditCategory' })
        this.okMsg('Saved successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Saving Class: ${errorMessage}`)
      }
    },

    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
